"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

// Client component injected into the public blog page when ?preview=1 is set.
// Listens for postMessage('blog-preview-refresh') from the admin panel that
// embeds this page in an iframe. On message, calls router.refresh() so the
// Server Component re-runs against the latest DB row — no full page reload,
// scroll position is preserved.
export default function PreviewRefresh() {
  const router = useRouter();
  useEffect(() => {
    function handler(e) {
      if (e.origin !== window.location.origin) return;
      if (e.data && e.data.type === "blog-preview-refresh") {
        router.refresh();
      }
    }
    window.addEventListener("message", handler);
    // Tell the parent admin panel "I'm ready" — used so the parent knows
    // when a fresh iframe load has completed and it's safe to postMessage.
    try {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(
          { type: "blog-preview-ready" },
          window.location.origin,
        );
      }
    } catch {
      // cross-origin block — preview not embedded in admin, ignore
    }
    return () => window.removeEventListener("message", handler);
  }, [router]);
  return null;
}
